module.exports = __webpack_public_path__ + "img/926.d8145a09.png";